<template>
  <div class="related">
    <div class="related__container container container--l">
      <h3 v-text="$store.getters.ui.related_label" />
      <div class="related__thumbs">
        <div class="related__slider swiper-container" ref="relatedSlider">
          <div class="related__wrapper swiper-wrapper">
            <div class="related__slide thumb swiper-slide" @click="$emit('goToBeverage', beverage)"
              v-for="(beverage, b, index) in uniqueBeverages" :key="'beverage'+b"
              :style="{backgroundColor:beverage.color}">
             <img @click="$emit('goToBeverage', beverage)" v-if="beverage.sizes[0].alt_title" :src="getDefaultImage(beverage)" class="thumb__image  thumb__image--related" :alt="beverage.sizes[0].alt_title" :title="beverage.sizes[0].alt_title" />
                <img v-else @click="$emit('goToBeverage', beverage)" :src="getDefaultImage(beverage)" :alt="beverage.title" :title="beverage.title" class="thumb__image thumb__image--related" />
                <div class="thumb__title thumb__title--related" style="display:flex; flex-direction: column;">
                  <span style="cursor: pointer;" @click="$emit('goToBeverage', beverage)">
                
                  {{beverage.title}}
                  </span>
                  {{category.title}}
                </div>

                  <span style="cursor: pointer;" class="link-related" @click="$emit('goToBeverage', beverage)"><span>{{$store.state.ui.read_more_label}} <i class="more__arrow more__category"></i></span></span>
            </div>
          </div>
        </div>
        <div class="related__nav related__nav--prev swiper-button-prev"
          ref="relatedPrev" v-show="hasSwiper" />
        <div class="related__nav related__nav--next swiper-button-next"
          ref="relatedNext" v-show="hasSwiper" />
      </div>
    </div>
  </div>
</template>

<script>
import ifDefined from '@/tools/ifDefined'

import Swiper from 'swiper/dist/js/swiper.js'

export default {
  name: 'RelatedBeverages',
  props: { beverages: {} },
  data() {
    return {
      hasSwiper: false,
      uniqueBeverages: {},
      swiper: null,
      speed: 300
    }
  },
  computed: {
    category() {
      return ifDefined(this.$store.getters.page.parent)
        ? this.$store.getters.page.parent
        : this.$store.getters.page
    }
  },
  methods: {
    getDefaultImage(beverage) {
      var o = {}
      if (beverage.sizes) {
        beverage.sizes.forEach((b, i) => {
          if (Number(b.show_default) === 1) {
            o = this.mediaPath(b['size_image_' + this.$store.getters.lang])
          }
        })
      }
      return o
    },
    getUniqueBeverages(slug) {
      var u = { ...this.beverages }
      delete u[slug]
      Object.keys(u).forEach(b => {
        if (u[b].deleted !== 0) {
          delete u[b]
        }
      })
      this.uniqueBeverages = u
    },
    beverageURL(slug) {
      return '/' + this.category.slug + '/' + slug
    },
    initRelatedSwiper() {
      this.swiper = new Swiper(this.$refs['relatedSlider'], {
        speed: this.speed,
        spaceBetween: 12,
        slidesPerView: 4,
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        },
        simulateTouch: false,
        loop: true,
        on: {
          init: () => {
            this.hasSwiper = true
          }
        },
        navigation: {
          nextEl: this.$refs['relatedNext'],
          prevEl: this.$refs['relatedPrev']
        }
      })
    }
  },
  beforeMount() {
    this.getUniqueBeverages(this.$route.name)
  },
  mounted() {
    if (
      (this.$store.getters.device.winW < 769 &&
        Object.keys(this.uniqueBeverages).length > 2) ||
      Object.keys(this.uniqueBeverages).length > 4
    ) {
      this.initRelatedSwiper()
    } else {
    }
  },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        this.getUniqueBeverages(to.name)
      }, 600)
      if (this.hasSwiper) {
        setTimeout(() => {
          this.swiper.update()
        }, 601)
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/RelatedBeverages.vue